import { Injectable, signal } from '@angular/core';
import { AUTH_TRANSLATIONS } from '../i18n/auth.translations';
import { LANDING_TRANSLATIONS } from '../i18n/landing.translations';
import { Lang } from '../i18n/translations.types';

const TRANSLATIONS = {
  es: {
    ...AUTH_TRANSLATIONS.es,
    ...LANDING_TRANSLATIONS.es,
  },
  en: {
    ...AUTH_TRANSLATIONS.en,
    ...LANDING_TRANSLATIONS.en,
  },
};

@Injectable({ providedIn: 'root' })
export class LanguageService {
  currentLang = signal<Lang>('es');

  constructor() {
    if (typeof window === 'undefined') return;

    const saved = localStorage.getItem('wm-lang');
    if (saved === 'es' || saved === 'en') {
      this.apply(saved);
      return;
    }

    const nav = typeof navigator !== 'undefined' ? navigator.language : '';
    if (nav?.toLowerCase().startsWith('en')) {
      this.apply('en');
      return;
    }

    this.apply('es');
  }

  setLang(lang: Lang) {
    this.apply(lang);
  }

  t(key: string, vars?: Record<string, string | number>) {
    const lang = this.currentLang();
    const fallback = TRANSLATIONS.es[key] ?? key;
    let text = TRANSLATIONS[lang]?.[key] ?? fallback;
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        text = text.replace(`{${k}}`, String(v));
      });
    }
    return text;
  }

  private apply(lang: Lang) {
    this.currentLang.set(lang);
    document.documentElement.lang = lang;
    localStorage.setItem('wm-lang', lang);
  }
}
